export class Config {
    remotebusid: number;
    isSHROn: boolean;
}

export class ConfigDiary {
    calRowHeight?: number;
    calScaleInMin?: number;
    calView?: number;
    switchViewPlan?: number;
    fromHour?: string;
    toHour?: string;
    isISocket: boolean;
    forceCreateCustomer: boolean;
    isMustMadeAppoinment?: boolean;
}